import { defineStore } from 'pinia'
import { useStore } from './DefaultStore';
import Cookies from "js-cookie";
import { getAuth, signOut } from 'firebase/auth';
import ToastService from '@/services/ToastService';
import AuthenticationService from '@/services/AuthenticationService';

export const useSessionStore = defineStore({  
  id: 'sessionStore',

  state: () => (
    {
    }
  ),

  actions: {
    async LogOut(){
        const auth = getAuth();
        const store = useStore();

        signOut(auth);
        store.SetLoader(true);
        
        await AuthenticationService.Logout()
        .then(() => {
          store.LoggedUser = null;
        })
        .catch(e => {
            ToastService.Error(e.message ?? 'OCURRIÓ UN ERROR AL INTENTAR CERRAR LA SESIÓN');
        })

        store.SetLoader(false);
    },

    async SessionLogout() {
      const store = useStore();
      store.SetLoader(true);

      await AuthenticationService.Logout()
        .then(() => {
          store.LoggedUser = null;
        })
        .catch(e => {
          ToastService.Error(e.message ?? 'OCURRIÓ UN ERROR AL INTENTAR CERRAR LA SESIÓN');
        })

      store.SetLoader(false);
    },

    async FirebaseLogout() {
      const auth = getAuth();
      const store = useStore();
      signOut(auth);
      store.LoggedUser = null;
    },

    SetCurrentOrganization(PKOrganization){
        Cookies.set('OrganizationID', PKOrganization);
    },
    
    GetCurrentOrganization(){
        let currentOrganization = Cookies.get('OrganizationID');
        return currentOrganization ? parseInt(currentOrganization) : null;
    }
  }
})